import {
  panelDimensions,
  solarCellThickness,
} from '../../model/helper/verandaDimensions'
import { SolarPanelGeometry } from './SolarPanelGeometry'
import { useSolarPanelMaterial } from './useSolarPanelMaterial'
import { useCellCountAndOffset } from './useCellCountAndOffset'

const generalOffset = [
  panelDimensions / 2.0,
  panelDimensions / 2.0,
  -solarCellThickness / 2,
]

export const SolarPanels = () => {
  const {
    countLength,
    countWidth,
    offsetLength,
    offsetWidth,
    startOffsetLength,
    startOffsetWidth,
  } = useCellCountAndOffset()

  const panelPositions = []
  for (let indexX = 0; indexX < countWidth; indexX++) {
    for (let indexY = 0; indexY < countLength; indexY++) {
      const x = indexX * offsetWidth + generalOffset[0]
      const y = indexY * offsetLength + generalOffset[1]

      panelPositions.push([x, generalOffset[2], y])
    }
  }

  const solarPanelMaterial = useSolarPanelMaterial()

  let position = [startOffsetWidth, 0, startOffsetLength]

  return (
    <group position={position as any}>
      {panelPositions.map((data, index) => {
        return (
          <SolarPanelGeometry
            key={`panelPositions${index}`}
            position={data}
            material={solarPanelMaterial}
          />
        )
      })}
    </group>
  )
}
